











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class PageHead extends Vue {
  @Prop() public pageTitle!: string;
  @Prop() public callInProgress!: true;
}
